import { cn } from "@/lib/utils";

interface OptimizedImageProps {
  src: string;
  alt: string;
  className?: string;
  priority?: boolean;
  loading?: "lazy" | "eager";
}

const OptimizedImage = ({ src, alt, className, priority = false, loading }: OptimizedImageProps) => {
  const imageUrl = src.startsWith('http')
    ? src
    : src.startsWith('public/')
      ? src.replace('public/', '/')
      : src.startsWith('/')
        ? src
        : `/${src}`;

  return (
    <img
      src={imageUrl}
      alt={alt}
      className={className}
      loading={loading ?? (priority ? "eager" : "lazy")}
      decoding={priority ? "sync" : "async"}
      {...(priority ? { fetchPriority: "high" as const } : {})}
      onError={(e) => {
        e.currentTarget.src = '/placeholder.svg';
      }}
    />
  );
};

export default OptimizedImage;
